import { MutableRefObject, useEffect, useState } from 'react'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { scrollingContainerRef } from 'components/Dashboard/DashboardScrollingContainer'
import { useLocation } from '@reach/router'
import { Setter } from 'utils'

export const useHideTooltipOnScroll = (
  hideRef: MutableRefObject<(() => void) | undefined>,
  dropdownScrollingContainerRef?: MutableRefObject<HTMLDivElement | null>,
  // shouldHideOnMainContentScroll is useful when it is necessary to hide the tooltip when scrolling not only the container but also the main content
  shouldHideOnMainContentScroll?: boolean,
): {
  setShouldIgnoreHideOnScroll: Setter<boolean>
} => {
  const isDesktop = useBreakpointIndex() === 2
  const location = useLocation()
  const isDashboard = location.pathname.includes('dashboard')
  const [shouldIgnoreHideOnScroll, setShouldIgnoreHideOnScroll] = useState(false)

  useEffect(() => {
    if (isDesktop && !dropdownScrollingContainerRef?.current) {
      return
    }

    const handleScroll = () => {
      if (!shouldIgnoreHideOnScroll) {
        hideRef.current?.()
      }
    }

    const mainContentScrollElement = isDashboard
      ? scrollingContainerRef.current
      : window['___gatsby'] || document

    const scrollingElement = dropdownScrollingContainerRef?.current || mainContentScrollElement

    scrollingElement?.addEventListener('scroll', handleScroll)

    if (shouldHideOnMainContentScroll) {
      mainContentScrollElement?.addEventListener('scroll', handleScroll)
    }

    return () => {
      scrollingElement?.removeEventListener('scroll', handleScroll)

      if (shouldHideOnMainContentScroll) {
        mainContentScrollElement?.removeEventListener('scroll', handleScroll)
      }
    }
  }, [
    hideRef,
    isDesktop,
    isDashboard,
    dropdownScrollingContainerRef,
    shouldHideOnMainContentScroll,
    shouldIgnoreHideOnScroll,
  ])

  return {
    setShouldIgnoreHideOnScroll,
  }
}
